import { Typography } from '@mui/material'
import { LanguageType, Unit } from '@eo-storefronts/eo-core'
import { useEoValue } from '~/src/hooks/useEoState'
import { LANGUAGE_STATE } from '~/src/stores/lang'

interface Props {
  unit: Unit | null,
}

const ProductUnit = ({ unit }: Props) => {
  const lang: LanguageType = useEoValue(LANGUAGE_STATE)

  if (!unit) {
    return null
  }

  return (
    <Typography
      component='span'
      variant='body2'
    >
      {`/${unit.nameShort[lang]}`}
    </Typography>
  )
}

export default ProductUnit
